import { useEffect, useState } from "react";
import { cachedGet } from "../api";
import { accountLinks, exploreLinks, legalLinks, site } from "../content";
import { useSession } from "../session";
import Logo from "./Logo";

export default function Footer() {
  const { token } = useSession();
  const [email, setEmail] = useState("");

  useEffect(() => {
    cachedGet("/api/v1/public/site")
      .then((result) => setEmail(result.data?.supportEmail || ""))
      .catch(() => {});
  }, []);
  return (
    <footer className="footer">
      <div className="wrap footer-grid">
        <section>
          <Logo as="p" />
          <p>Member site for published packages, referral income, transfers and withdrawals.</p>
          <p>
            {email ? <a href={`mailto:${email}`}>{email}</a> : "Support email has not been published yet."}
          </p>
          <p>{site.support.hours}</p>
          <p className="fine">{site.support.hoursNote}</p>
        </section>

        <section>
          <h2>Explore</h2>
          <ul>
            {exploreLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </section>

        <section>
          <h2>Account</h2>
          <ul>
            {token ? (
              <li>
                <a href="#/dashboard">Dashboard</a>
              </li>
            ) : (
              accountLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))
            )}
          </ul>
        </section>

        <section id="legal">
          <h2>Legal</h2>
          <ul>
            {legalLinks.map((link) => (
              <li key={link.label}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
          <p className="fine">
            Version {site.legal.version} · Effective {site.legal.effective}. Full legal text appears here when it is
            published.
          </p>
        </section>
      </div>

      <div className="wrap copyright">
        <p>© 2026 {site.name}</p>
      </div>
    </footer>
  );
}
